import { useState } from 'react';
import styles from './BankStatements.module.css';
import TrueLayerLink from './TrueLayer/TrueLayerLink';
import ManualUpload from './ManualUpload';
import { FormattedMessage } from 'react-intl';
import messages from './BankStatements.messages';
import { TStatus } from '../../NewDocUploads.types';
import Required from '../../DocumentRequirement/Required';
import Completed from '../../DocumentRequirement/Completed';
import { tracking } from '@iwoca/frontend-tracking-library';

type TResolutionMethod = 'manual' | 'truelayer';

const BankStatements = ({
    quantifier,
    status,
    showStatus
}: {
    quantifier: number;
    status: TStatus;
    showStatus: boolean;
}) => {
    const [resolutionMethod, setResolutionMethod] =
        useState<TResolutionMethod>('truelayer');

    return (
        <>
            <div className={styles.headerSection}>
                <div className={styles.title}>
                    <h4 data-testid="bank-statements">
                        {resolutionMethod === 'truelayer' ? (
                            <strong>Choose which bank account to link</strong>
                        ) : (
                            <FormattedMessage
                                {...messages.title}
                                values={{
                                    strongText: (
                                        <strong>
                                            Business bank statements
                                        </strong>
                                    ),
                                    duration:
                                        quantifier > 1
                                            ? `${quantifier} months`
                                            : '1 month'
                                }}
                            />
                        )}
                    </h4>
                    {showStatus &&
                        (status === 'required' || status === 'error') && (
                            <Required />
                        )}
                    {(status === 'pending' || status === 'completed') && (
                        <Completed />
                    )}
                </div>
            </div>

            {resolutionMethod === 'truelayer' ? (
                <TrueLayerLink
                    toggleManualUpload={() => {
                        setResolutionMethod('manual');
                        tracking.ampli.newDocUploadsClickedManualBankStatementSection();
                    }}
                />
            ) : (
                <ManualUpload
                    toggleLinkBankAccount={() => {
                        setResolutionMethod('truelayer');
                        tracking.ampli.newDocUploadsClickedLinkBankAccountSection();
                    }}
                />
            )}
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default BankStatements;
